
import { ButtonFieldConfig, DynamicFormArray, FormFieldConfig, Props } from './form.model';
import { SpinIdNumber, DealerNumber, defaultSearchContainerButtons, AreaMutipleSelect, DistrictMutipleSelect, CodeMutipleSelect, FieldNames, BrandDropdown } from './form-fields.model';
import { DataTableSchema, DefaultTableSchema, TableColumnSchema } from './dynamic-data-table.model';
import { FETCH_METHODS, SearchConfig } from './api.model';


const FormFieldArray: FormFieldConfig[] = structuredClone([
  SpinIdNumber, DealerNumber, { ...structuredClone(BrandDropdown), showSelect: false, multiple:true,defaultValue:['LEXUS','TOYOTA']}, AreaMutipleSelect,
  { ...structuredClone(DistrictMutipleSelect), options: [{ fieldLabel: '01', fieldValue: '01' }, { fieldLabel: '02', fieldValue: '02' }, { fieldLabel: '03', fieldValue: '03' }, { fieldLabel: '04', fieldValue: '04' }, { fieldLabel: '05', fieldValue: '05' }, { fieldLabel: '06', fieldValue: '06' }] },
  CodeMutipleSelect]);

const FormButtonArray: ButtonFieldConfig[] = structuredClone(defaultSearchContainerButtons);

export const AseRejectionReportTitle = "ASE Rejection Report";

export const RejectionReportSearchConfig: SearchConfig = {
  method: FETCH_METHODS['Post'],
  path: 'aseRejectionReport',
  body: {
    [FieldNames.SpinId]: "",
    [FieldNames.DealerNumber]: "",
    [FieldNames.Area]: "",
    [FieldNames.District]: "",
    [FieldNames.Code]: ""
  }
}

export const optionExplanations: Array<any> = [
  "N = NO MATCH(ASE ID# and SPIN does not match and/or no ASE credit to send)",
  "NR = NO RELEASE(This box can only be unchecked by the Tech)",
  "SX = ASE BLOCKED CREDIT(Incomplete experience information)",
  "EX = ASE BLOCKED CREDIT(Certification Expired)",
  "BL = ASE BLOCKED CREDIT(Tech needs to call; i.e ASE payment due)"
]

export const AseRejectionReportFormArray: DynamicFormArray = {
  FieldsArray: FormFieldArray,
  ButtonsArray: FormButtonArray,
  autoSearchOnLoad: true
}

const AseRejectionReportColumnSchema: Array<TableColumnSchema> = [
  { label: 'SPIN ID', fieldKey: 'spinId', sticky: true },
  { label: 'DEALER', fieldKey: 'dealerCode', sticky: true },
  { label: 'FIRST NAME', fieldKey: 'firstName' },
  { label: 'LAST NAME', fieldKey: 'lastName' },
  { label: 'Area/Region', fieldKey: 'area' },
  { label: 'DISTRICT', fieldKey: 'district' },
  { label: 'CODE', fieldKey: 'code', isNotCamelCase: true },
  { label: 'COURSES', fieldKey: 'courses', isNotCamelCase: true },
]


export const AseRejectionReportTableSchema: DataTableSchema = {
  ...structuredClone(DefaultTableSchema),
  columnSchema: AseRejectionReportColumnSchema,
  searchInfo: {
    placeholder: 'Filter',
    filtarableSpecificFields: []
  },
  exportConfig: {
    fileName: 'Ase-Rejection-Report',
    exportMessage: "ASE Rejection Data",
    isCamelCase: ['area', 'lastName', 'firstName'],
    schema: {
      spinId: "SPIN ID",
      dealerCode: "DEALER CODE",
      firstName: "FIRST NAME",
      lastName: "LAST NAME",
      area: "Area/Region",
      district: "DISTRICT",
      code: "CODE",
      courses: "COURSES"
    }
  }
}

export const AseRejectionReportProps: Props = {
  optionExplanation: optionExplanations,
}